import React, { useEffect } from 'react';

import { Grid, Typography, makeStyles } from '@material-ui/core';

import useBlocRef from '../../utils/useBlocRef.hook';
import LoadingButton from '../common/LoadingButton';

const useStyles = makeStyles(() => {
  return {
    additionalFilesContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      marginBottom: '16px',
      marginTop: '24px',
      minHeight: '90px',
      textAlign: 'left',
    },
    additionalTitle: {
      color: '#172B4D',
      fontSize: '18px',
      fontWeight: 'bold',
      marginBottom: '1rem',
    },
    sectionText: {
      color: '#999',
      fontSize: '12px',
      marginTop: '1rem',
    },
  };
});

export default ({ caseData }) => {
  if (!caseData) return null;
  const classes = useStyles();

  const blocRef = useBlocRef('patientDashboardBloc');
  useEffect(() => blocRef.current.selectedRecord$.next({ ...caseData, caseId: caseData.id }), [caseData, blocRef]);

  const handleFileUpload = () => {
    blocRef.current.openAdditionalFileDialog(true);
  };

  return (
    <div className={classes.additionalFilesContainer}>
      <Grid item>
        <Typography className={classes.additionalTitle}>Additional Files</Typography>
        <Grid item>
          <Typography className={classes.sectionText}>You can upload additional files to this case.</Typography>
        </Grid>
        <Grid item style={{ marginTop: '1rem' }}>
          <LoadingButton color="primary" variant="contained" size="large" onClick={handleFileUpload}>
            Upload File
          </LoadingButton>
        </Grid>
      </Grid>
    </div>
  );
};
